import { createAction } from '@reduxjs/toolkit';

import type { FeedbackType } from '../constants';

const modulesPrefix = 'user-feedback';

export const sendFeedbackType = createAction<FeedbackType>(`${modulesPrefix}/sendFeedbackType`);
